export const friendlyBubbleText = (val: string, maxChars: number) => {
    return val.length > maxChars ? `${val.slice(0, maxChars)}...` : val;
};
